export default {
  selectable: false,
  slideContainer: true,
};
